// extracted by mini-css-extract-plugin
export default {"container":"NoIXgm0og7Jsxl5eLPu0mA=="};